import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PageLayoutModule } from '../../page-layout/page-layout.module';

import { BetriebskontakteComponent } from './betriebskontakte.component';
import { BetriebskontaktCardModule } from './betriebskontakt-card.module';
import { BetriebskontakteBearbeitenDialogComponent } from './betriebskontakte-bearbeiten-dialog.component';
import { BetriebskontakteErstellenDialogComponent } from './betriebskontakte-erstellen-dialog/betriebskontakte-erstellen-dialog.component';
import { BetriebskontakteDialogsModule } from './betriebskontakte-dialogs.module';

@NgModule({
    declarations: [
        BetriebskontakteComponent,
        BetriebskontakteBearbeitenDialogComponent,
        BetriebskontakteErstellenDialogComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatTooltipModule,
        MatDialogModule,
        MatCheckboxModule,
        PageLayoutModule,
        BetriebskontaktCardModule,
        BetriebskontakteDialogsModule,
    ],
    exports: [BetriebskontakteComponent, BetriebskontaktCardModule],
})
export class BetriebskontakteModule {}
